import React, { useEffect } from 'react'

import TextArea from './TextArea'
import LinkCard from './LinkCard'
import Iframe from './Iframe'
import ImageWithText from './ImageWithText'
import CenterImage from './CenterImage'
import Talk from './Talk'
import Quotation from './Quotation'
import Profile from './Profile'
import { ArticleContent as Content } from '@models/Article'
import ArtisanImageWithText from '@src/components/Artisan/ArtisanImageWithText'

type ArticleContentProps = {
  contents: Content[]
  isMasked: boolean
  isArtisan?: boolean
}

const ArticleContent: React.FC<ArticleContentProps> = ({
  contents,
  isMasked,
  isArtisan,
}) => {
  useEffect(() => {
    // JSでのページ遷移時にwindow.instagramが存在すると処理が実行されないため、直接実行する
    // https://help.microcms.io/ja/knowledge/caution-of-instagram-embed
    if (window.instgrm !== undefined) {
      // API呼び出しの参考: https://developers.facebook.com/docs/instagram/oembed
      window.instgrm.Embeds.process()
    }
    if (window.twttr !== undefined) {
      window.twttr.widgets.load()
    }
  }, [])

  if (isArtisan) {
    return (
      <>
        {contents.map((content: Content, index: number) => {
          let component

          switch (content.fieldId) {
            case 'textarea':
              component = <TextArea {...content} index={index} />
              break
            case 'card':
            case 'link':
              component = <LinkCard {...content} isArtisan />
              break
            case 'iframe':
              component = <Iframe {...content} isArtisan />
              break
            case 'leftImage':
            case 'rightImage':
              component = (
                <ArtisanImageWithText {...content} isMasked={isMasked} />
              )
              break
            case 'centerImage':
              component = <CenterImage {...content} isArtisan />
              break
            case 'talk':
              component = <Talk {...content} />
              break
            case 'pre':
              component = <Quotation {...content} isArtisan />
              break
            case 'profile':
              component = <Profile {...content} isArtisan />
              break
            default:
              console.log(`不明なitemです: ${content}`)
          }

          if (isMasked && index === contents.length - 1) {
            return (
              <div
                key={`item-${index}`}
                style={{
                  maskImage:
                    'linear-gradient(to top, transparent, black 300px)',
                }}
              >
                {component}
              </div>
            )
          }

          return <div key={`item-${index}`}>{component}</div>
        })}
      </>
    )
  }

  return (
    <>
      {contents.map((content: Content, index: number) => {
        let component

        switch (content.fieldId) {
          case 'textarea':
            component = <TextArea {...content} index={index} />
            break
          case 'card':
          case 'link':
            component = <LinkCard {...content} />
            break
          case 'iframe':
            component = <Iframe {...content} />
            break
          case 'leftImage':
          case 'rightImage':
            component = <ImageWithText {...content} />
            break
          case 'centerImage':
            component = <CenterImage {...content} />
            break
          case 'talk':
            component = <Talk {...content} />
            break
          case 'pre':
            component = <Quotation {...content} />
            break
          case 'profile':
            component = <Profile {...content} />
            break
          default:
            console.log(`不明なitemです: ${content}`)
        }

        if (isMasked && index === contents.length - 1) {
          return (
            <div
              key={`item-${index}`}
              style={{
                maskImage: 'linear-gradient(to top, transparent, black 300px)',
              }}
            >
              {component}
            </div>
          )
        }

        return <div key={`item-${index}`}>{component}</div>
      })}
    </>
  )
}

export default ArticleContent
